webpackJsonp([94551500655095],{

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(15)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getDairiesBySlug = getDairiesBySlug;
	
	var _axios = __webpack_require__(7);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actionTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDairiesBySlug(slug1, slug2) {
	  return function (dispatch) {
	    dispatch({ type: _actionTypes.FETCH_DAIRIES_REQUEST });
	    return (0, _axios2.default)({
	      url: ("https://api.gas.tn") + '/dairy/dairies?slug=' + slug1 + ',' + slug2 + '&&thisweek=true',
	      method: 'get'
	    }).then(function (response) {
	      dispatch({ type: _actionTypes.FETCH_DAIRIES_SUCCESS, payload: response.data });
	    }).catch(function (error) {
	      dispatch({ type: _actionTypes.FETCH_DAIRIES_FAILURE, payload: error });
	    });
	  };
	}

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ChooseGroupSlug = undefined;
	
	var _actionTypes = __webpack_require__(2);
	
	var ChooseGroupSlug = exports.ChooseGroupSlug = function ChooseGroupSlug(slug) {
	  return function (dispatch) {
	    dispatch({ type: _actionTypes.CHOOSE_GROUP_SLUG, payload: slug });
	  };
	};

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/treesome-logo.1222d0cb.svg";

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutTreesome = function (_Component) {
	  _inherits(AboutTreesome, _Component);
	
	  function AboutTreesome() {
	    _classCallCheck(this, AboutTreesome);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AboutTreesome.prototype.render = function render() {
	    return _react2.default.createElement(
	      "section",
	      { className: this.props.background, id: "about" },
	      _react2.default.createElement(
	        "div",
	        { className: "container mt-5 mb-5" },
	        _react2.default.createElement(
	          "div",
	          { className: "row pt-2 pb-2" },
	          _react2.default.createElement(
	            "span",
	            { className: "col-12 txt-bold-40px txt-green txt-uppercase" },
	            "Restaurant & Bar a tapas"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "col-12 txt-thin" },
	            "C\u2019est entre cr\xE9ativit\xE9 et inventivit\xE9 qu\u2019on pr\xE9sente le treesome.",
	            _react2.default.createElement("br", null),
	            "Une histoire simple, sobre et efficace qui passe d\u2019un style \xE0 un autre ou d\u2019un univers \xE0 l\u2019autre.",
	            _react2.default.createElement("br", null),
	            "Un festival de couleur et de texture \xE0 parsemer et \xE0 mixer sans mod\xE9ration pour composer",
	            _react2.default.createElement("br", null),
	            "des sous-espaces douillets avec un style tr\xE8s d\xE9cal\xE9.",
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "col-12 txt-thin" },
	            "The treesome est avant tout un espace de rencontre et de partage entre les diff\xE9rentes cat\xE9gories qui compose",
	            _react2.default.createElement("br", null),
	            "notre soci\xE9t\xE9 ; \xE9tudiants, fonctionnaires, artistes un m\xE9lange social et culturel de tout genre.",
	            _react2.default.createElement("br", null),
	            "Tout comme pour la brochette de service qu\u2019on sugg\xE8re \xE0 nos client\xE8les."
	          )
	        )
	      )
	    );
	  };
	
	  return AboutTreesome;
	}(_react.Component);
	
	exports.default = AboutTreesome;
	module.exports = exports["default"];

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_moment2.default.locale('fr');
	
	var OneEvent = function OneEvent(_ref) {
	  var date = _ref.date,
	      day = _ref.day,
	      artist = _ref.artist,
	      subtitle = _ref.subtitle,
	      description = _ref.description,
	      dir = _ref.dir;
	  return _react2.default.createElement(
	    'div',
	    { className: 'event text-' + dir + ' txt-white m-3' },
	    _react2.default.createElement(
	      'span',
	      { className: 'txt-bold txt-25px txt-uppercase' },
	      date
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'txt-thin m-3' },
	      ' ',
	      day,
	      ' '
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'txt-bold txt-25px txt-uppercase' },
	      artist
	    ),
	    description && _react2.default.createElement('span', {
	      className: 'fa fa-info-circle',
	      style: { marginLeft: 8, fontSize: 20, color: 'rgba(255, 255, 255, .8)' },
	      onClick: function onClick() {
	        return alert(description);
	      }
	    }),
	    subtitle && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        { className: 'txt-thin', style: { marginLeft: 90 } },
	        subtitle
	      )
	    )
	  );
	};
	
	var PerformingTreesome = function (_Component) {
	  _inherits(PerformingTreesome, _Component);
	
	  function PerformingTreesome() {
	    _classCallCheck(this, PerformingTreesome);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PerformingTreesome.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'treesome-performing-bg', id: 'events' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-6 col-sm-12 text-right bg-darkned event-box' },
	          _react2.default.createElement(
	            'div',
	            { className: 'txt-uppercase txt-white' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'txt-bold txt-25px event-box-title' },
	              'per-'
	            ),
	            _react2.default.createElement(
	              'h1',
	              { className: 'txt-bold txt-25px event-box-title' },
	              'forming'
	            )
	          ),
	          _react2.default.createElement('hr', { className: 'txt-separator float-right' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'txt-uppercase txt-thin txt-spaced-2' },
	            'this week'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-6 col-sm-12 align-items-start event-box' },
	          this.props.data.length > 0 ? this.props.data.map(function (item) {
	            return _react2.default.createElement(OneEvent, {
	              date: (0, _moment2.default)(item.date).date(),
	              day: (0, _moment2.default)(item.date).format('ddd').toUpperCase(),
	              artist: item.name,
	              subtitle: item.subTitle,
	              description: item.description,
	              dir: 'left'
	            });
	          }) : _react2.default.createElement(
	            'div',
	            { className: 'txt-thin p-5 m-5' },
	            'Pas des performing programm\xE9s pour cette semaine.'
	          )
	        )
	      )
	    );
	  };
	
	  return PerformingTreesome;
	}(_react.Component);
	
	exports.default = PerformingTreesome;
	module.exports = exports['default'];

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(5);
	
	var _scrolling = __webpack_require__(26);
	
	var _treesomeLogo = __webpack_require__(141);
	
	var _treesomeLogo2 = _interopRequireDefault(_treesomeLogo);
	
	var _Gallery = __webpack_require__(29);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Header = __webpack_require__(30);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _NavigationBar = __webpack_require__(31);
	
	var _NavigationBar2 = _interopRequireDefault(_NavigationBar);
	
	var _Contact = __webpack_require__(27);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _AboutTreesome = __webpack_require__(260);
	
	var _AboutTreesome2 = _interopRequireDefault(_AboutTreesome);
	
	var _Events = __webpack_require__(65);
	
	var _Events2 = _interopRequireDefault(_Events);
	
	var _PerformingTreesome = __webpack_require__(261);
	
	var _PerformingTreesome2 = _interopRequireDefault(_PerformingTreesome);
	
	var _SlugAction = __webpack_require__(94);
	
	var _EventsAction = __webpack_require__(23);
	
	var _GallerieAction = __webpack_require__(24);
	
	var _DairiesAction = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderContent = _react2.default.createElement(
	  'div',
	  { className: 'pt-3 pb-3' },
	  _react2.default.createElement('img', {
	    className: 'treesome-header-logo mt-5 mb-5',
	    src: _treesomeLogo2.default,
	    style: {
	      width: 250
	    }
	  })
	);
	
	var Treesome = function (_Component) {
	  _inherits(Treesome, _Component);
	
	  function Treesome(props) {
	    _classCallCheck(this, Treesome);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      menus: [],
	      images: [],
	      items: [],
	      dairies: []
	    };
	    return _this;
	  }
	
	  Treesome.prototype.componentDidMount = function componentDidMount() {
	    this.props.getGallery('treesomesousse');
	    this.props.getEventsBySlug('treesomesousse');
	    this.props.ChooseGroupSlug('treesomesousse');
	    this.props.getDairiesBySlug('treesomesousse');
	    var about = _reactDom2.default.findDOMNode(this.refs.about);
	    var events = _reactDom2.default.findDOMNode(this.refs.events);
	    var performing = _reactDom2.default.findDOMNode(this.refs.performing);
	    var gallery = _reactDom2.default.findDOMNode(this.refs.gallery);
	
	    this.props.savingNodesPositions({
	      treesome: {
	        about: about.offsetTop,
	        events: events.offsetTop,
	        performing: performing.offsetTop,
	        gallery: gallery.offsetTop
	      }
	    });
	  };
	
	  Treesome.prototype.render = function render() {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _Header2.default,
	        { content: HeaderContent, background: 'treesome-header-bg' },
	        _react2.default.createElement(_NavigationBar2.default, {
	          slug: 'treesome',
	          navigations: [{ name: 'about', txt: 'About' }, { name: 'events', txt: 'Events' }, { name: 'performing', txt: 'Performing' }, { name: 'gallery', txt: 'Gallery' }]
	        })
	      ),
	      _react2.default.createElement(_AboutTreesome2.default, { ref: 'about', background: 'treesome-about-bg' }),
	      _react2.default.createElement(_Events2.default, { ref: 'events', background: 'treesome-event-bg', data: this.props.events }),
	      _react2.default.createElement(_PerformingTreesome2.default, { ref: 'performing', data: this.props.dairy }),
	      _react2.default.createElement(_Gallery2.default, { ref: 'gallery', background: 'treesome-gallery-bg', medias: this.props.gallerie }),
	      _react2.default.createElement(_Contact2.default, { ref: 'contact', minimal: true, color: '#128f24', placeholders: '#004719', background: 'treesome-about-bg', info: info }),
	      _react2.default.createElement(_Footer2.default, { color: '#128f24', secondColor: '#004719' })
	    );
	  };
	
	  return Treesome;
	}(_react.Component);
	
	var info = {
	  facebook: 'https://www.facebook.com/treesomesousse/',
	  insta: 'https://www.instagram.com/the_treesome/',
	  youtube: '',
	  tripAdvisor: '',
	  address: _react2.default.createElement(
	    'span',
	    null,
	    'SOCIETE " G A S " SARL 6ET, IMM "VENUS" A 6-4, Golf Advanced Services, 1082 CENTRE URB NORD'
	  )
	};
	
	exports.default = (0, _reactRedux.connect)(function (store) {
	  return {
	    scrolling: store.scrolling,
	    gallerie: store.gallerie,
	    events: store.events,
	    dairy: store.dairy
	  };
	}, {
	  savingNodesPositions: _scrolling.savingNodesPositions,
	  ChooseGroupSlug: _SlugAction.ChooseGroupSlug,
	  getEventsBySlug: _EventsAction.getEventsBySlug,
	  getGallery: _GallerieAction.getGallery,
	  getDairiesBySlug: _DairiesAction.getDairiesBySlug
	})(Treesome);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-treesomesousse-jsx-343c55bd7227e1585062.js